export function embedOverlay() {
  // Function to handle '.wp-block-embed'
  var videoContainers = document.querySelectorAll('.wp-block-embed');

  videoContainers.forEach(videoContainer => {
      // Create overlay element
      var overlay = document.createElement('div');
      overlay.classList.add('wp-block-embed__overlay');
      overlay.onclick = function() {
          overlay.style.display = 'none';
          var video = videoContainer.querySelector('iframe');
          video.src += "&autoplay=1";
      };

      // Append overlay to video container
      videoContainer.appendChild(overlay);
  });

  // Function to handle '.farlo-ui-video'
  const farloVideoContainers = document.querySelectorAll('.farlo-ui-video');

  farloVideoContainers.forEach(container => {
      const iframe = container.querySelector('iframe');

      if (iframe && iframe.dataset.src) {
          iframe.src = iframe.dataset.src;
      }
  });
}
